<div class="container">
    <div class="text-center my-5">
      <img class="mb-4" src="assets/404.svg">
      <h1 class="mb-2" i18n="@@pageNotFound">Page not found</h1>
      <p class="mb-4" i18n="@@thisPageCannotBeFound">This page cannot be found. It might be a broken link or the URL is simply incorrect.</p>
      <button class="button-primary" routerLink="/" routerLinkActive="active" i18n="@@backToHome">Back to Home</button>
    </div>
</div>
